import angular from 'angular';
import { ssDialogService, loaderService, orgDataService } from 'app/services';
import copy from 'app/constants';
import { alerts } from 'app/components/global';
import beginServiceTrialDialog from '../beginServiceDialog';
import customerServicesDirective from './customer-services.directive';
import customerServiceDirective from './customer-service.directive';
import CustomerServiceDirectiveController from './customer-service.directive.controller';


export default angular.module('app.components.admin.customerAdministration.services', [
  copy,
  alerts,
  loaderService,
  orgDataService,
  ssDialogService,
  beginServiceTrialDialog
])
  .directive('caCustomerService', customerServiceDirective)
  .controller('CACustomerServiceDirectiveController', CustomerServiceDirectiveController)
  .directive('caCustomerServices', customerServicesDirective)
  .controller('CACustomerServicesDirectiveController', () => { /* only here to provide scope vm */ })
  .name;

console.log('app.admin.customerAdministration.services created');
